export const comments_3389027 = {"data":{"data":[],"links":{}}}